import { Clickable, H2, P } from '@ahmdigital/ui';
import { get } from 'lodash/fp';
import { useSelector } from 'react-redux';

import { JourneyProductType } from '../../../build-your-cover/types';
import AddYourDetailsFields from '../add-your-details-fields';
import AgeField from '../../../../components/pricing-drawer/components/customer-form/components/age-field';
import constants from '../../../../ahm-constants';
import IncomeTierField from '../../../../components/pricing-drawer/components/customer-form/components/income-tier-field';
import IncomeTypeField from '../../../../components/pricing-drawer/components/customer-form/components/income-type-field';
import PaymentFrequencyField from '../../../../components/pricing-drawer/components/customer-form/components/payment-frequency-field';
import ProductTypeField from '../product-type-field';
import ScaleField from '../../../../components/pricing-drawer/components/customer-form/components/scale-field';
import StateField from '../../../../components/pricing-drawer/components/customer-form/components/state-field';

type Props = {
  handleChangeProductType?: (productType: JourneyProductType) => void;
  hasSubmitAttempt: boolean;
  showPaymentFrequency?: boolean;
};

const RefinePriceFormFields = ({ handleChangeProductType, hasSubmitAttempt, showPaymentFrequency = true }: Props) => {
  const location = useSelector(get('router.location'));
  return (
    <>
      <ScaleField label="I’m looking for..." />

      <ProductTypeField handleChangeProductType={handleChangeProductType} />

      <StateField label="Living in" />

      {showPaymentFrequency && (
        <PaymentFrequencyField label="Payment frequency" variant="marginBottomSpacer11" location={location} />
      )}

      <H2 looksLike="h5" variant="marginBottomSpacer10">
        Your government rebate
      </H2>
      <P variant="marginBottomSpacer8">
        If you’re eligible for Medicare, the government may pay a percentage of your premium through the{' '}
        <Clickable to={constants.URLS.HELP.WHAT_IS_AGR} inNewTab>
          Australian Government Rebate (AGR)
        </Clickable>{' '}
        depending on your age and income.
      </P>

      <AgeField showTooltip={false} isProductWithHospitalServices hasSubmitAttempt={hasSubmitAttempt} />

      <IncomeTypeField />

      <IncomeTierField showTooltip showExplainer={false} />

      <AddYourDetailsFields />
    </>
  );
};

export default RefinePriceFormFields;
